// store/menuStore.ts
import { NestedLink } from "@/features/ui/Menu";
import { create } from "zustand";

interface MenuStore {
  visibleMenus: NestedLink[];
  setVisibleMenus: (menus: NestedLink[]) => void;
}

export const useMenuStore = create<MenuStore>((set) => ({
  visibleMenus: [],
  setVisibleMenus: (menus) => set({ visibleMenus: menus }),
}));
